
module.directive('newCertificateForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/certificates/newCertificateForm',
        scope: {participantId: '=', certificateNames: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
            return ModelService.postRelation('participant',
                                             scope.participantId,
                                             'certificates',
                                             data);
            }
        }
    }
});

module.directive('certificateEditForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/certificates/certificateEditForm',
        scope: {certificate: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = ModelService.copyFields(scope.certificate);
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.certificate, data);
            }
        }
    }
})
